import { EnvironmentProviders, Provider } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';

/**
 * PrimeNG + animations, provided once at the application root.
 *
 * These used to hang off the `chat-with-ali` and `campaign-preview` routes to
 * keep the marketing bundle lean. That stopped being true the moment the
 * floating Ali launcher moved into `landing-page-shell`: it carries the entry
 * card, the card carries the auth dialog, and the shell wraps every marketing
 * page. So `p-dialog` was opening on the home page inside an injector with no
 * theme and no animations — the visitor pressed Continue and got an unstyled
 * box. Route-level providers cannot cover a component that lives above them.
 *
 * The theme itself (the preset, ~100 KB) is not here: the auth dialog fetches it
 * as it is created (shared/primeng-theme.ts), so no page's first load carries it.
 */
export const primeNgProviders: Array<Provider | EnvironmentProviders> = [
  provideAnimationsAsync(),
  providePrimeNG({}),
];
